export default __webpack_public_path__ + "static/media/04.4dd06acb.svg";